import React from 'react'
import { graphql } from 'gatsby'
import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Monolith from '@/components/Monolith'
import BackButton from '@/components/BackButton'
import Share from '@/components/Share'
import dasherize from '@/utilities/dasherize'
import List from '@/components/List'

const hashtags = ['chile3d2022']

const Winner = ({ data }) => {
  const { categoria, marca } = data.googleSpreadsheetCat

  return (
    <Layout>
      <SEO
        title={`${marca}, ganador ${categoria}, Premios Chile 3D - Especiales La Tercera`}
      />
      <Monolith category={categoria} brand={marca} />

      <Share
        url={`https://especiales.latercera.com/premios-chile3d-2022/ganadores-por-categoria/${dasherize(
          marca,
        )}-${dasherize(categoria)}/`}
        title={`${marca}, ganador ${categoria}, premios Chile 3D - Especiales La Tercera`}
        twitterhandle="latercera"
        hashtags={hashtags}
      />
      <List />
    </Layout>
  )
}

export default Winner

export const query = graphql`
  query winnerSingle($id: String!) {
    googleSpreadsheetCat(id: { eq: $id }) {
      id
      categoria: categor_a
      marca
    }
  }
`
